export const pokedexGen7 = {
  "pokedex722": "Bauz",
  "pokedex723": "Arboretoss",
  "pokedex724": "Silvarro",
  "pokedex725": "Flamiau",
  "pokedex726": "Miezunder",
  "pokedex727": "Fuegro",
  "pokedex728": "Robball",
  "pokedex729": "Marikeck",
  "pokedex730": "Primarene",
  "pokedex731": "Peppeck",
  "pokedex732": "Trompeck",
  "pokedex733": "Tukanon",
  "pokedex734": "Mangunior",
  "pokedex735": "Manguspektor",
  "pokedex736": "Mabula",
  "pokedex737": "Akkup",
  "pokedex738": "Donarion",
  "pokedex739": "Krabbox",
  "pokedex740": "Krawell",
  "pokedex741": "Choreogel",
  "pokedex742": "Wommel",
  "pokedex743": "Bandelby",
  "pokedex744": "Wuffels",
  "pokedex745": "Wolwerock",
  "pokedex746": "Lusardin",
  "pokedex747": "Garstella",
  "pokedex748": "Aggrostella",
  "pokedex749": "Pampuli",
  "pokedex750": "Pampross",
  "pokedex751": "Araqua",
  "pokedex752": "Aranestro",
  "pokedex753": "Imantis",
  "pokedex754": "Mantidea",
  "pokedex755": "Bubungus",
  "pokedex756": "Lamellux",
  "pokedex757": "Molunk",
  "pokedex758": "Amfira",
  "pokedex759": "Velursi",
  "pokedex760": "Kosturso",
  "pokedex761": "Frubberl",
  "pokedex762": "Frubaila",
  "pokedex763": "Fruyal",
  "pokedex764": "Curelei",
  "pokedex765": "Kommandutan",
  "pokedex766": "Quartermak",
  "pokedex767": "Reißlaus",
  "pokedex768": "Tectass",
  "pokedex769": "Sankabuh",
  "pokedex770": "Colossand",
  "pokedex771": "Gufa",
  "pokedex772": "Typ:Null",
  "pokedex773": "Amigento",
  "pokedex774": "Meteno",
  "pokedex775": "Koalelu",
  "pokedex776": "Tortunator",
  "pokedex777": "Togedemaru",
  "pokedex778": "Mimigma",
  "pokedex779": "Knirfish",
  "pokedex780": "Sen-Long",
  "pokedex781": "Moruda",
  "pokedex782": "Miniras",
  "pokedex783": "Mediras",
  "pokedex784": "Grandiras",
  "pokedex785": "Kapu-Riki",
  "pokedex786": "Kapu-Fala",
  "pokedex787": "Kapu-Toro",
  "pokedex788": "Kapu-Kime",
  "pokedex789": "Cosmog",
  "pokedex790": "Cosmovum",
  "pokedex791": "Solgaleo",
  "pokedex792": "Lunala",
  "pokedex793": "Anego",
  "pokedex794": "Masskito",
  "pokedex795": "Schabelle",
  "pokedex796": "Voltriant",
  "pokedex797": "Kaguron",
  "pokedex798": "Katagami",
  "pokedex799": "Schlingking",
  "pokedex800": "Necrozma",
  "pokedex801": "Magearna",
  "pokedex802": "Marshadow",
  "pokedex803": "Venicro",
  "pokedex804": "Agoyon",
  "pokedex805": "Muramura",
  "pokedex806": "Kopplosio",
  "pokedex807": "Zeraora",
  "pokedex808": "Meltan",
  "pokedex809": "Melmetal",
};